<template>
  <v-container
    id="operation-parameters"
    fluid
    tag="section"
  >
    <base-material-card
      inline
      icon="mdi-cellphone"
      :title="`${$t('sidebar.devices').toUpperCase()}`"
      class="px-5 py-3"
    >
      <!-- Bouton-->
      <v-col
        cols="12"
        sm="12"
      >
        <v-btn-toggle
          v-model="toggleButtonActiveInactive"
          mandatory
        >
          <!--Rapport pour le client -->
          <v-btn
            value="actif"
            text
            color="blue"
            @click="toggleButtonActiveInactive = 'actif'"
          >
            <v-icon
              center
              class="mr-1"
              color="blue"
            >
              mdi-power
            </v-icon>

            {{ $t('Active') }}
          </v-btn>

          <!-- UBR Responsable-->
          <v-btn
            value="inactif"
            text
            color="blue"
            @click="toggleButtonActiveInactive = 'inactif'"
          >
            <v-icon
              center
              class="mr-1"
              color="blue"
            >
              mdi-power-sleep
            </v-icon>
            {{ $t('Inactive') }}
          </v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col
        cols="12"
        sm="12"
      >
        <!-- Ajouter un appareil-->
        <v-col
          class="text-right ml-4"
          cols="12"
        >
          <v-btn
            color="success"
            @click="addItem(null)"
          >
            {{ $t('Add') }}
            <v-icon
              right
              dark
            >
              mdi-plus-circle-outline
            </v-icon>
          </v-btn>
        </v-col>

        <v-data-table
          :headers="tableHeaders"
          :items="table"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :single-expand="true"
          hide-default-footer
          :search="search"
          item-key="id"
          show-expand
          :expanded.sync="expanded"
          @page-count="pageCount = $event"
          @item-expanded="resetExpanded"
        >
          <!-- Search-->
          <template #top>
            <v-text-field
              v-model="search"
              :label="$t('search')"
              class="mx-4"
            />
          </template>

          <!-- Action-->
          <template
            slot="item.action"
            slot-scope="props"
          >
            <!-- Activer les appareils-->
            <v-btn
              v-if="!getIfActiveOrInactive(props.item.appareils)"
              fab
              dark
              x-small
              color="success"
              :title="$t('Enable')"
              @click="enableAll(props.item.appareils)"
            >
              <v-icon>mdi-power</v-icon>
            </v-btn>

            <!-- Désactiver les appareils-->
            <v-btn
              v-else
              class="ml-2"
              fab
              dark
              x-small
              color="red"
              :title="$t('Disable')"
              @click="disableAll(props.item.appareils)"
            >
              <v-icon>mdi-power-sleep</v-icon>
            </v-btn>

            <!-- Copier tous les appareils-->
            <v-btn
              class="ml-2"
              fab
              dark
              x-small
              color="blue"
              :title="$t('devices.Copy_devices')"
              @click="copyAll(props.item.appareils)"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>

          <template #expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row align="center">
                <v-col
                  cols="6"
                >
                  <v-btn
                    v-if="selected.length"
                    x-small
                    color="blue"
                    @click="editMultipleItems"
                  >
                    {{ $t('devices.Multiple_edition') }}
                  </v-btn>
                </v-col>
                <v-col
                  class="text-right"
                  cols="6"
                >
                  <v-btn
                    x-small
                    color="success"
                    @click="addItem(item.appareils[0])"
                  >
                    {{ $t('Add') }}
                    <v-icon
                      right
                      dark
                    >
                      mdi-plus-circle-outline
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table
                v-model="selected"
                class="mb-5"
                dark
                dense
                :headers="tableHeadersDevices"
                :items="item.appareils"
                :single-select="false"
                show-select
                item-key="id"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <!--  Couleur hex-->
                <template
                  slot="item.couleurHex"
                  slot-scope="props"
                >
                  <v-avatar
                    v-if="props.item.couleurHex"
                    :color="props.item.couleurHex"
                    size="25"
                  />
                </template>
                <!--  Rupture de stock-->
                <template
                  slot="item.rupture"
                  slot-scope="props"
                >
                  <v-icon
                    v-if="props.item.rupture"
                    color="primary"
                  >
                    mdi-check
                  </v-icon>
                </template>

                <!--  Afficher Prix-->
                <template
                  slot="item.afficherPrix"
                  slot-scope="props"
                >
                  <v-icon
                    v-if="props.item.afficherPrix"
                    color="primary"
                  >
                    mdi-check
                  </v-icon>
                </template>

                <!-- Actif-->
                <template
                  slot="item.actif"
                  slot-scope="props"
                >
                  <v-icon
                    v-if="props.item.actif"
                    color="primary"
                  >
                    mdi-check
                  </v-icon>
                </template>

                <!-- Prix-->
                <template
                  slot="item.prix"
                  slot-scope="props"
                >
                  <span v-if="props.item.prix">{{ props.item.prix.toFixed(2) }} $</span>
                </template>

                <!-- Action-->
                <template
                  slot="item.action"
                  slot-scope="props"
                >
                  <!-- Edit-->
                  <v-btn
                    fab
                    dark
                    x-small
                    color="success"
                    :title="$t('Edit')"
                    @click="editItem(props.item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  <v-btn
                    class="ml-2"
                    fab
                    dark
                    x-small
                    color="red"
                    :title="$t('Delete')"
                    @click="deleteItem(props.item.id)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>

        <div class="text-center pt-2">
          <v-pagination
            v-model="page"
            :length="pageCount"
          />
          <v-row
            justify="center"
            align="center"
          >
            <v-col
              cols="12"
              sm="4"
            >
              <v-select
                v-model="itemsPerPage"
                :items="itemsPage"
                :label="$t('table.Items_per_page')"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </base-material-card>

    <!-- Édition et ajout-->
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="submitForm">
        <validation-observer
          ref="obs"
          v-slot="{ handleSubmit }"
        >
          <form>
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="dialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <!-- Édition multiple-->
              <v-toolbar-title v-if="submitType === 'editMultiple'">
                {{ $t('devices.Multiple_edition') }}
              </v-toolbar-title>
              <!-- Ajout ou simple édition-->
              <v-toolbar-title v-else>
                {{ submitType === 'edit' ? $t('Edit') : $t('Add') }} {{ $t('devices.a_device') }}
              </v-toolbar-title>
              <v-spacer />
            </v-toolbar>

            <!-- Compagnie-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Company') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="$t('devices.Company')"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.compagnie"
                    placeholder="Apple, Samsung etc..."
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Modèle-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Model') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="$t('devices.Model')"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.modele"
                    placeholder="Iphone 16, Iphone 16 pro etc..."
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Stockage-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Storage') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="$t('devices.Storage')"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.stockage"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Couleur francais-->
            <!-- On affiche pas si édition multiple-->
            <v-row
              v-if="submitType !== 'editMultiple'"
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Color') }} {{ $t('French') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="`${$t('devices.Color')} ${$t('French')}`"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.couleurFr"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Couleur anglais-->
            <!-- On affiche pas si édition multiple-->
            <v-row
              v-if="submitType !== 'editMultiple'"
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Color') }} {{ $t('English') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="`${$t('devices.Color')} ${$t('English')}`"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.couleurEn"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Couleur Hex-->
            <!-- On affiche pas si édition multiple-->
            <v-row
              v-if="submitType !== 'editMultiple'"
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Color') }} HEX
              </v-col>

              <v-col cols="1">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="`${$t('devices.Color')} HEX`"
                  :rules="{ required: false, regex: /^#(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/ }"
                >
                  <v-text-field
                    v-model="submitForm.couleurHex"
                    placeholder="#F2ADDA"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>

              <v-col cols="8">
                <v-avatar
                  :color="submitForm.couleurHex"
                  size="35"
                />
                <small class="grey--text ml-3">{{ $t('devices.Color_hex_message_validation') }}</small>
              </v-col>

              <v-col
                cols="12"
                offset-md="2"
              >
                <small class="grey--text ml-4">{{ $t('devices.Color_hex_message') }}</small>
              </v-col>
            </v-row>

            <!-- Prix-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Price') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="$t('devices.Price')"
                  :rules="{ required: submitType === 'editMultiple' ? false : true, min_value:1, regex: /^(?!^$)\d*[0-9]?(?:\.[0-9]{1,2})?$/ }"
                >
                  <v-text-field
                    v-model="submitForm.prix"
                    placeholder="10.00"
                    type="number"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Afficher Prix-->
            <!-- On affiche pas si édition multiple-->
            <v-row
              v-if="submitType !== 'editMultiple'"
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Display_price') }}
              </v-col>

              <v-col cols="8">
                <v-checkbox
                  v-model="submitForm.afficherPrix"
                  :label="$t('devices.label.Display_price')"
                />
              </v-col>
            </v-row>

            <!-- Rupture de stock-->
            <!-- On affiche pas si édition multiple-->
            <v-row
              v-if="submitType !== 'editMultiple'"
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Out_of_stock') }}
              </v-col>

              <v-col cols="8">
                <v-checkbox
                  v-model="submitForm.rupture"
                  :label="$t('devices.label.Out_of_stock')"
                  @change="changeOutOfOrder"
                />
              </v-col>
            </v-row>

            <!-- Rupture de stock message-->
            <template v-if="submitForm.rupture">
              <!-- Rupture de stock message français-->
              <!-- On affiche pas si édition multiple-->
              <v-row
                v-if="submitType !== 'editMultiple'"
                align="center"
                dense
              >
                <v-col
                  class="text-right text-body-1 grey--text mr-4"
                  cols="2"
                >
                  {{ $t('devices.Out_of_stock') }} {{ $t('French') }}
                </v-col>

                <v-col cols="8">
                  <validation-provider
                    v-slot="{ errors, valid }"
                    :name="`${$t('devices.Out_of_stock')} ${$t('French')}`"
                    rules="required"
                  >
                    <v-text-field
                      v-model="submitForm.ruptureMessageFr"
                      :placeholder="$t('devices.placeholder.rupture1')"
                      :error-messages="errors"
                      :success="valid"
                      required
                    />
                  </validation-provider>
                </v-col>
              </v-row>

              <!-- Rupture de stock message anglais-->
              <!-- On affiche pas si édition multiple-->
              <v-row
                v-if="submitType !== 'editMultiple'"
                align="center"
                dense
              >
                <v-col
                  class="text-right text-body-1 grey--text mr-4"
                  cols="2"
                >
                  {{ $t('devices.Out_of_stock') }} {{ $t('English') }}
                </v-col>

                <v-col cols="8">
                  <validation-provider
                    v-slot="{ errors, valid }"
                    :name="`${$t('devices.Out_of_stock')} ${$t('English')}`"
                    rules="required"
                  >
                    <v-text-field
                      v-model="submitForm.ruptureMessageEn"
                      :placeholder="$t('devices.placeholder.rupture2')"
                      :error-messages="errors"
                      :success="valid"
                      required
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </template>

            <!-- actif-->
            <!-- On affiche pas si édition multiple-->
            <v-row
              v-if="submitType !== 'editMultiple'"
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('Active') }}
              </v-col>

              <v-col cols="8">
                <v-checkbox
                  v-model="submitForm.actif"
                  :label="$t('devices.label.Active')"
                />
              </v-col>
            </v-row>

            <div class="pa-3 text-center">
              <!--  Bouton annuler-->
              <v-btn
                color="error"
                @click="dialog = false"
              >
                {{ $t('Cancel') }}
              </v-btn>
              <!--  Bouton submit-->
              <v-btn
                color="success"
                class="ml-3"
                @click="handleSubmit(submit)"
              >
                {{ $t('Validate') }}
              </v-btn>
            </div>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>

    <!-- Copie-->
    <v-dialog
      v-model="dialogCopy"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="submitForm">
        <validation-observer
          ref="obsCopy"
          v-slot="{ handleSubmit }"
        >
          <form>
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="dialogCopy = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>
                {{ $t('devices.Copy_devices') }}
              </v-toolbar-title>
              <v-spacer />
            </v-toolbar>

            <!-- Compagnie-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Company') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="$t('devices.Company')"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.compagnie"
                    placeholder="Apple, Samsung etc..."
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Modèle-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Model') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="$t('devices.Model')"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.modele"
                    placeholder="Iphone 16, Iphone 16 pro etc..."
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Stockage-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Storage') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="$t('devices.Storage')"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.stockage"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Prix-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right text-body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('devices.Price') }}
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  :name="$t('devices.Price')"
                  :rules="{ required: submitType === 'editMultiple' ? false : true, min_value:1, regex: /^(?!^$)\d*[0-9]?(?:\.[0-9]{1,2})?$/ }"
                >
                  <v-text-field
                    v-model="submitForm.prix"
                    placeholder="10.00"
                    type="number"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <div class="pa-3 text-center">
              <!--  Bouton annuler-->
              <v-btn
                color="error"
                @click="dialogCopy = false"
              >
                {{ $t('Cancel') }}
              </v-btn>
              <!--  Bouton submit-->
              <v-btn
                color="success"
                class="ml-3"
                @click="handleSubmit(submitCopy)"
              >
                {{ $t('Validate') }}
              </v-btn>
            </div>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  // Services
  import AppareilsService from '@/services/01Cell/AppareilsService'
  // Other
  import {
    ValidationObserver,
    ValidationProvider,
  } from 'vee-validate'
  import Swal from 'sweetalert2'

  export default {
    name: 'OperationDevices',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    data () {
      return {
        toggleButtonActiveInactive: 'actif',
        search: '',
        submitForm: {},
        submitType: null,
        table: [],
        expanded: [],
        selected: [],
        tableHeaders: [
          { text: '', value: 'data-table-expand' },
          { text: this.$i18n.t('devices.Company'), value: 'compagnie', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('devices.Model'), value: 'modele', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('devices.Storage'), value: 'stockage', sortable: true, class: 'text-h4 primary--text' },
          { text: 'Action', value: 'action', sortable: false, align: 'end', class: 'text-h4 primary--text', width: 150 },
        ],
        tableHeadersDevices: [
          { text: `${this.$i18n.t('devices.Color')} ${this.$i18n.t('French')}`, value: 'couleurFr', sortable: true, class: 'text-h4 primary--text' },
          { text: `${this.$i18n.t('devices.Color')} ${this.$i18n.t('English')}`, value: 'couleurEn', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('devices.Color'), value: 'couleurHex', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('devices.Price'), value: 'prix', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('devices.Storage'), value: 'stockage', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('devices.Out_of_stock'), value: 'rupture', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('devices.Display_price'), value: 'afficherPrix', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('Active'), value: 'actif', sortable: true, class: 'text-h4 primary--text' },
          { text: 'Action', value: 'action', sortable: false, align: 'end', class: 'text-h4 primary--text', width: 150 },
        ],
        page: 1,
        pageCount: 0,
        itemsPerPage: 50,
        itemsPage: [5, 10, 25, 50, 100],
        dialog: false,
        dialogCopy: false,
        devicesToCopy: [],
      }
    },

    computed: {
    },

    watch: {
      'toggleButtonActiveInactive' () {
        this.getData()
      },
    },

    mounted () {
      this.getData()
    },

    methods: {
      resetExpanded () {
        this.selected = []
      },
      async getData () {
        // Start Spinner
        this.$loading.show()
        try {
          this.table = await AppareilsService.listByGroup(this.toggleButtonActiveInactive)
          // Stop Spinner
          this.$loading.hide()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
      getIfActiveOrInactive (devices) {
        return devices.every(item => item.actif)
      },
      enableAll (devices) {
        Swal.fire({
          icon: 'warning',
          title: this.$i18n.t('Are_you_sure'),
          text: `${this.$i18n.t('devices.Enable_devices')} ?`,
          showCancelButton: true,
          cancelButtonText: this.$i18n.t('Cancel'),
        }).then(async (result) => {
          if (result.value) {
            // Start Loader
            this.$loading.show()
            try {
              const idArray = Array.from(devices, x => x.id)
              const body = { id: idArray, data: { actif: true } }
              await AppareilsService.bulkUpdate(body)
              this.getData()
            } catch (error) {
              console.log(error)
              this.getData()
            }
          }
        })
      },
      disableAll (devices) {
        Swal.fire({
          icon: 'warning',
          title: this.$i18n.t('Are_you_sure'),
          text: `${this.$i18n.t('devices.Disable_devices')} ?`,
          showCancelButton: true,
          cancelButtonText: this.$i18n.t('Cancel'),
        }).then(async (result) => {
          if (result.value) {
            // Start Loader
            this.$loading.show()
            try {
              const idArray = Array.from(devices, x => x.id)
              const body = { id: idArray, data: { actif: false } }
              await AppareilsService.bulkUpdate(body)
              this.getData()
            } catch (error) {
              console.log(error)
              this.getData()
            }
          }
        })
      },
      copyAll (devices) {
        this.devicesToCopy = devices
        // Reset du submit
        this.submitForm = {}
        this.submitForm.compagnie = devices[0].compagnie
        this.submitForm.modele = devices[0].modele
        this.dialogCopy = true
      },
      changeOutOfOrder (event) {
        if (!event) {
          this.submitForm.ruptureMessageEn = null
          this.submitForm.ruptureMessageFr = null
        }
      },
      async editItem (item) {
        // Start Spinner
        this.$loading.show()
        try {
          // Edit
          this.submitType = 'edit'
          // Paramètre
          this.submitForm = await AppareilsService.view(item.id)
          // Show dialog
          this.dialog = true
          // Stop Spinner
          this.$loading.hide()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
      async editMultipleItems () {
        // Reset du submit
        this.submitForm = {}
        this.submitForm.compagnie = this.selected[0].compagnie
        this.submitForm.modele = this.selected[0].modele
        this.submitForm.stockage = this.selected[0].stockage
        this.submitType = 'editMultiple'
        // Show dialog
        this.dialog = true
      },
      addItem (device) {
        // Ajout
        this.submitType = 'add'
        // Reset du submit
        this.submitForm = {}
        this.submitForm.actif = true

        if (device) {
          // Les champs à copier
          this.submitForm.compagnie = device.compagnie
          this.submitForm.modele = device.modele
          this.submitForm.stockage = device.stockage
          this.submitForm.prix = device.prix
          this.submitForm.afficherPrix = device.afficherPrix
        }
        // Show dialog
        this.dialog = true
      },
      deleteItem (id) {
        // SweetAlert
        Swal.fire({
          icon: 'warning',
          title: this.$i18n.t('Are_you_sure'),
          text: `${this.$i18n.t('devices.Delete')} ?`,
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: this.$i18n.t('Yes_delete_it'),
          cancelButtonText: this.$i18n.t('Cancel'),
        }).then(async (result) => {
          if (result.value) {
            // Start Loader
            this.$loading.show()
            try {
              await AppareilsService.remove(id)
              this.getData()
            } catch (error) {
              console.log(error)
              this.getData()
            }
          }
        })
      },
      async submit () {
        // Hide dialog
        this.dialog = false

        // Start Spinner
        this.$loading.show()
        try {
          if (this.submitType === 'edit') {
            await AppareilsService.update(this.submitForm, this.submitForm.id)
          } else if (this.submitType === 'add') {
            await AppareilsService.save(this.submitForm)
          } else if (this.submitType === 'editMultiple') {
            const request = []
            this.selected.forEach(currentItem => {
              const body = {
                compagnie: this.submitForm.compagnie,
                modele: this.submitForm.modele,
                stockage: this.submitForm.stockage,
                prix: this.submitForm.prix,
              }

              // Si il n'y a pas de nouveau prix, on ne le mets pas à jour
              if (!this.submitForm.prix) delete body.prix

              request.push(AppareilsService.update(body, currentItem.id))
            })
            this.selected = []
            await Promise.all(request)
          }
          this.getData()
        } catch (error) {
          console.log(error)
          console.log(error)
          this.getData()
        }
      },
      async submitCopy () {
        // Hide dialog
        this.dialogCopy = false

        // Start Spinner
        this.$loading.show()
        try {
          const newDevices = this.devicesToCopy.map(item => {
            delete item.id
            item.compagnie = this.submitForm.compagnie
            item.modele = this.submitForm.modele
            item.stockage = this.submitForm.stockage
            item.prix = this.submitForm.prix
            return item
          })

          await AppareilsService.bulkCreate(newDevices)
          this.devicesToCopy = []
          this.getData()
        } catch (error) {
          console.log(error)
          this.getData()
        }
      },
    },
  }
</script>
